export default "__VITE_ASSET__BAEiwonD__"